// routes
import { paths } from 'src/routes/paths';
// utils
import axios from 'src/utils/axios';

// ----------------------------------------------------------------------
const TOKEN_STORAGE_KEY = 'accessToken';
function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );
 // console.log('jsonPayload',jsonPayload);

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();
  // console.log('currentTime=',currentTime);

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = (exp *1000)  - currentTime;
  // console.log('timeLeft=> ',timeLeft);
  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token is expired. Please log in again.');
    localStorage.removeItem(TOKEN_STORAGE_KEY);

    window.location.href = paths.auth.jwt.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

const USER_STORAGE_KEY = 'user';

export const setToken = (accessToken) => {
  if (accessToken) {
    localStorage.setItem(TOKEN_STORAGE_KEY, accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    localStorage.removeItem(TOKEN_STORAGE_KEY);

    delete axios.defaults.headers.common.Authorization;
  }
};

export const getToken = () => {
  const accessToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  return accessToken;
};

export const setUser = (user) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
}

export const getUser = () => {
  const user = localStorage.getItem(USER_STORAGE_KEY);
  return user ? JSON.parse(user) : '';
}

